import ForgetPassword from "./forgetPassword";

export default ForgetPassword;
